import classNames from 'classnames'
import { useState } from 'react';
import React from 'react'
import { FcInspection } from "react-icons/fc";
import { Link, useLocation } from 'react-router-dom'
import { DASHBOARD_SIDEBAR_BOTTOM_LINKS, DASHBOARD_SIDEBAR_LINKS } from './lib/consts/Pnavigation';
import { HiOutlineLogout } from 'react-icons/hi'
import { useBreakpointValue } from '@chakra-ui/react';

import {
  Card,
  CardHeader,
  CardBody,
  CardFooter,
  StackDivider,

} from '@chakra-ui/react';

import {
  Heading,
  Avatar,
  Box,
  Center,
  Image,
  Flex,
  Text,
  Stack,

  Badge,
  Button,
  useColorModeValue,
  Divider,
  SimpleGrid,
} from '@chakra-ui/react';
import { useDisclosure } from '@chakra-ui/react';
import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalFooter,
  ModalBody,
  ModalCloseButton,
} from '@chakra-ui/react'

import { SmallCloseIcon } from '@chakra-ui/icons';

import {


  FormControl,
  FormLabel,

  Input,


  HStack,

  AvatarBadge,
  IconButton,

} from '@chakra-ui/react';

const linkClasses ='flex items-center gap-2 font-light px-3 py-2 hover:bg-neutral-700 hover:no-underline active:bg-neutral-600 rounded-sm text-3xl'
export default function Psidebar() {
  const [isOpen, setIsOpen] = useState(false);
  const isMobile = useBreakpointValue({ base: true, lg: false });

  const handleToggle = () => {
    setIsOpen((prevState) => !prevState);
  };

  return (
    <>
      {isMobile ? (
        <div className="bg-neutral-900  p-3 flex flex-row justify-between items-center text-white">
          {/* <div>
            <FcInspection size={30} />
            <span className="text-neutral-100 text-3xl ml-2">Dashboard</span>
          </div> */}
          <div
            className="text-neutral-100 cursor-pointer"
            onClick={handleToggle}
          >
            <span className="text-3xl">{isOpen ? '-' : '+'}</span>
          </div>
        </div>
      ) : (
        <div className="bg-neutral-900 w-80 p-3 flex flex-col text-white">
          <div className="flex items-center gap-2 px-1 py-3">
            <FcInspection size={30} />
            <span className="text-neutral-100 text-3xl">My Profile</span>
          </div>

          <div className="flex-1 py-8 flex flex-col gap-5">
            {DASHBOARD_SIDEBAR_LINKS.map((item) => (
              <SidebarLink key={item.key} item={item} />
            ))}
          </div>
          <div className="flex flex-col gap-0.5 pt-2 border-t border-neutral-700">
            {DASHBOARD_SIDEBAR_BOTTOM_LINKS.map((item) => (
              <SidebarLink key={item.key} item={item} />
            ))}
            <div className="text-red-500 cursor-pointer">
              <span className="text-xl">
                <HiOutlineLogout />
              </span>
              Logout
            </div>
          </div>
        </div>
      )}
      {isOpen && (
        <div className="bg-neutral-900 w-full p-3 flex flex-col text-white">
          {DASHBOARD_SIDEBAR_LINKS.map((item) => (
            <SidebarLink key={item.key} item={item} />
          ))}
          {DASHBOARD_SIDEBAR_BOTTOM_LINKS.map((item) => (
            <SidebarLink key={item.key} item={item} />
          ))}
          <div className="text-red-500 cursor-pointer">
            <span className="text-xl">
              <HiOutlineLogout />
            </span>
            Logout
          </div>
        </div>
      )}
    </>
  );
}

function SidebarLink({item}) {
  const { pathname } = useLocation()
  return(
    <Link to={item.path} className={classNames(pathname === item.path ? 'bg-neutral-700 text-white' : 'text-neutral-400',linkClasses)}>
      <span className='text-xl'>{item.icon}</span>
      {item.label}
    </Link>
  )
}